import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { PaymenttermService } from './paymentterm.service';
import { SetupService } from '../setup.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppMainComponent } from '../../../../app.main.component';
import { AddYearPipe } from 'src/app/shared/pipes/add-year.pipe';
import { ObjectNames, Severity, Status } from '../../constants/constants';
import { TitleCasePipe } from '@angular/common';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-paymentterm',
  templateUrl: './paymentterm.component.html',
  styleUrls: ['./paymentterm.component.scss']
})
export class PaymenttermComponent implements OnInit, OnChanges {

  @Input() index;
  @Input() displayPaymentTermAdd: boolean = false;
  @Output() closeDialog = new EventEmitter<boolean>();
  display: boolean = false;
  paymentTermForm: FormGroup;
  allPaymentTerms: any[] = [];
  addEditPaymentTermHeader: string;
  allTermTypes = [];
  isAddPaymentTerm: boolean = false;
  invalidData: boolean = false;
  termConstants = ObjectNames.setupConstants.Term;
  subscription: Subscription;

  constructor(private paymentTermService: PaymenttermService, private messageService: MessageService,
    private confirmationService: ConfirmationService, private fb: FormBuilder, private app: AppMainComponent,
    private setupService: SetupService, private yearPipe: AddYearPipe, private titlecasePipe: TitleCasePipe) { }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.index?.currentValue || changes?.index?.currentValue == 0) {
      this.index = changes?.index?.currentValue;
      this.loadPaymentTerm(this.index);
    }
    if (changes?.displayPaymentTermAdd?.currentValue) {
      this.display = changes?.displayPaymentTermAdd?.currentValue;
      this.showAddPaymentTerm();
    }
  }

  ngOnInit(): void {
    this.getPaymentTermGroup();
    this.paymentTermForm = this.fb.group({
      id: [0],
      createdSource: [this.app.userIP],
      updatedSource: [this.app.userIP],
      createdBy: [this.app.userId],
      updatedBy: [this.app.userId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()],
      organizationId: [this.app.companyId],
      name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      description: [''],
      statusId: [true],
      isValid: [true],
      validFromDate: [new Date().toISOString()],
      validToDate: [this.yearPipe.transform(new Date())],
      netDueDay: [''],
      nextMonthBeforeDue: [''],
      discount: [''],
      discountBefore: [''],
      typeId: [this.allTermTypes[0]]
    });
  }

  loadPaymentTerm(index) {
    this.paymentTermService.getPaymentTermList(index).subscribe((terms) => {
      this.allPaymentTerms = terms;
    })
  }

  getPaymentTermGroup() {
    this.paymentTermService.getAllGroups().subscribe((groups) => {
      const payemntTermGroup = groups.filter(group => group.name == ObjectNames.setupConstants.PaymentTermName)[0];
      this.getAllPaymentTermTypes(payemntTermGroup.id);
    })
  }

  getAllPaymentTermTypes(id) {
    this.paymentTermService.getAllPaymentTermTypes(id).subscribe((types) => {
      this.allTermTypes = types;
      this.paymentTermForm.controls['typeId'].setValue(this.allTermTypes[0]);
    })
  }

  checkPaymentTermStatus() {
    if (!this.isAddPaymentTerm && !this.paymentTermForm.controls['statusId'].value) {
      this.setupService.checkDeleteStatus(this.paymentTermForm.controls['id'].value, 'paymentTerm').subscribe(check => {
        if (!check.item1) {
          return
        } else {
          this.paymentTermForm.get("statusId").setValue(true);
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: `${check.item2}` });
        }
      })
    }
  }

  checkDeleteStatus(term) {
    this.setupService.checkDeleteStatus(term.id, 'paymentTerm',this.index).subscribe(check => {
      if (!check.item1) {
        this.deleteTerm(term);
      } else {
        this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: `${check.item2}` });
      }
    })
  }

  deleteTerm(term) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this Payment Term?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.paymentTermService.deletePaymentTerm(term.id, this.index).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Deleted Successfully...' });
          const index = this.allPaymentTerms.indexOf(term);
          this.allPaymentTerms.splice(index, 1);
        }).catch(() => {
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  showAddPaymentTerm() {
    if (this.index == 0) {
      this.addEditPaymentTermHeader = ObjectNames.setupConstants.AddPaymentTermTitle;
    } else {
      this.addEditPaymentTermHeader = ObjectNames.setupConstants.AddVendorPaymentTermTitle;
    }
    this.invalidData = false;
    this.isAddPaymentTerm = true;
    this.paymentTermForm = this.fb.group({
      id: [0],
      createdSource: [this.app.userIP],
      updatedSource: [this.app.userIP],
      createdBy: [this.app.userId],
      updatedBy: [this.app.userId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()],
      organizationId: [this.app.companyId],
      name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      description: [''],
      statusId: [true],
      isValid: [true],
      validFromDate: [new Date().toISOString()],
      validToDate: [this.yearPipe.transform(new Date())],
      netDueDay: [''],
      nextMonthBeforeDue: [''],
      discount: [''],
      discountBefore: [''],
      typeId: [this.allTermTypes[0]]
    });
  }

  resetFields() {
    this.paymentTermForm.controls['discount'].reset();
    this.paymentTermForm.controls['netDueDay'].reset();
    this.paymentTermForm.controls['discountBefore'].reset();
    this.paymentTermForm.controls['nextMonthBeforeDue'].reset();
    this.paymentTermForm.controls['description'].reset();
  }

  showEditPaymentTerm(term) {
    this.isAddPaymentTerm = false;
    this.invalidData = false;
    if (this.index == 0) {
      this.addEditPaymentTermHeader = ObjectNames.setupConstants.EditPaymentTermTitle;
    } else {
      this.addEditPaymentTermHeader = ObjectNames.setupConstants.EditVendorPaymentTermTitle;
    }
    this.display = true;
    this.paymentTermForm.patchValue(term);
    const filteredTermType = this.allTermTypes.filter(type => type.id == term.typeId)[0];
    this.paymentTermForm.controls['typeId'].setValue(filteredTermType);
    this.paymentTermForm.controls['statusId'].setValue(term.statusId == Status.ACTIVE ? true : false);
  }

  savePaymentTerm(value) {
    this.invalidData = false;
    if (value.typeId?.name == 'Other') {
      value.netDueDay = 0;
      value.nextMonthBeforeDue = 0;
      value.discount = 0;
      value.discountBefore = 0;
    }
    //StatusId 1-Active,2-InActive
    value.statusId = value.statusId == true ? Status.ACTIVE : Status.INACTIVE;
    value.typeId = value.typeId.id;
    const lowerCaseNames = [];
    if (this.isAddPaymentTerm) {
      for (let s of this.allPaymentTerms) {
        lowerCaseNames.push(s.name.toLowerCase().replace(/ /g, ''))
      }
      if (lowerCaseNames.indexOf(value.name.toLowerCase().replace(/ /g, '')) > -1) {
        this.invalidData = true;
      } else {
        this.paymentTermService.addPaymentTerm(value, this.index).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Payment Term Added successfully...' });
          this.loadPaymentTerm(this.index);
          this.display = false;
          this.closeDialog.emit();
        }).catch(() => {
          this.display = false;
          this.closeDialog.emit();
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
        });
      }
    } else {
      const duplicateRecord = this.allPaymentTerms.find(depOb => depOb.name.toLowerCase().replace(/ /g, '') == value.name.toLowerCase().replace(/ /g, '') && depOb.id !== value.id)
      if (duplicateRecord) {
        this.invalidData = true;
      } else {
        this.invalidData = false;
        value.updatedBy = this.app.userId;
        value.updatedDate = new Date().toISOString();
        value.updatedSource = this.app.userIP;
        this.paymentTermService.updatePaymentTerm(value, this.index).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Payment Term Updated successfully...' });
          this.loadPaymentTerm(this.index);
          this.display = false;
          this.closeDialog.emit();
        }).catch(() => {
          this.display = false;
          this.closeDialog.emit();
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
        });
      }
    }
  }

  hideDialog(){
    this.paymentTermForm.reset();
    this.closeDialog.emit();
  }

}
